import React from 'react';
import './AppearanceDrawer.css';

export const AppearanceDrawer: React.FC = () => {
  return (
    <div className="appearance-drawer">
      <div className="appearance-header">
        <div className="appearance-title">Appearance</div>
      </div>

      <div className="appearance-section">
        <div className="appearance-section-title">Theme</div>
        <div className="appearance-coming-soon" aria-label="Theme coming soon">
          Theme — <span className="appearance-coming-soon-accent">Coming Soon</span>
        </div>
      </div>

      <div className="appearance-section">
        <div className="appearance-section-title">Font size</div>
        <div className="appearance-coming-soon" aria-label="Font size coming soon">
          Font size — <span className="appearance-coming-soon-accent">Coming Soon</span>
        </div>
      </div>
    </div>
  );
};


